import { create } from 'zustand'

const initialActivities = []
export const useActivities = create((set) => ({
  activities: initialActivities,
  setActivities: (newActivities = []) => set((state) => ({ activities: newActivities })),
  addActivity: (activity) => set((state) => ({ activities: [...state.activities, activity] })),
}))

const initialRoutes = []
export const useRoutes = create((set) => ({
  routes: initialRoutes,
  addRoute: (newRoute) => set((state) => ({ routes: [...state.routes, newRoute] })),
  setRoutes: (newRoutes = []) => set((state) => ({ routes: newRoutes })),
}))

const initialCurrentActivity = {}
export const useCurrentActivity = create((set) => ({
  currentActivity: initialCurrentActivity,
  setCurrentActivity: (activity = {}) =>
    set((state) => ({
      currentActivity: activity,
    })),
}))

const initialCurrentRoute = null
export const useCurrentRoute = create((set) => ({
  currentRoute: initialCurrentRoute,
  setCurrentRoute: (route = {}) =>
    set((state) => ({
      currentRoute: route,
    })),
}))

const initialProcessTemplate = {}
export const useProcessTemplate = create((set) => ({
  processTemplate: initialProcessTemplate,
  setProcessTemplate: (processTemplate = {}) =>
    set((state) => ({
      processTemplate: processTemplate,
    })),
}))

const localMetadata = []
export const useLocalMetadata = create((set) => ({
  metadata: localMetadata,
  setMetadata: (meta = []) => set(() => ({ metadata: meta })),
}))
